export const mapObjectValues = <Key extends string, A, B>(
  object: Record<Key, A>,
  callbackFn: (a: A) => B,
) =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, callbackFn(value as A)]),
  ) as Record<Key, B>;
